var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnHelpMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15,
    stroke: "#2D72FE",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6001 25.5999H14.4001V22.3999H17.6001V25.5999Z",
    fill: "#2D72FE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4746 8.27442C12.6748 7.07419 14.3027 6.3999 16.0001 6.3999C17.6975 6.3999 19.3253 7.07419 20.5256 8.27442C21.7258 9.47465 22.4001 11.1025 22.4001 12.7999C22.4001 16.7999 17.6001 17.1999 17.6001 20.7999H14.4001C14.4001 15.5999 19.2001 15.9999 19.2001 12.7999C19.2001 11.9512 18.863 11.1373 18.2628 10.5372C17.6627 9.93705 16.8488 9.5999 16.0001 9.5999C15.1514 9.5999 14.3375 9.93705 13.7374 10.5372C13.1372 11.1373 12.8001 11.9512 12.8001 12.7999H9.6001C9.6001 11.1025 10.2744 9.47465 11.4746 8.27442Z",
    fill: "#2D72FE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnHelpMenu);
export default __webpack_public_path__ + "static/media/icn_help_menu.5c7a2bd3dfc4a09e6e02648d3fe2cef2.svg";
export { ForwardRef as ReactComponent };